import moment from 'moment'
import { getInsuranceQuoteKey } from './insuranceUtils'
import { FetchQuoteParams } from 'actions/InsuranceActions'
import { INSURANCE_PRODUCT_ID, INSURANCE_PRODUCT_TYPE } from 'constants/insurance'

/**
 * For insurance purposes, when the departure and arrival dates are the same, we add one day to the end date.
 * This is necessary because insurance quotes cannot start and end on the same day.
 */
function sanitizeEndDate(departingDate?: string, arrivalDate?: string) {
  return departingDate === arrivalDate ?
      moment(arrivalDate).add(1, 'day').format('YYYY-MM-DD') :
    arrivalDate
}

export function getInsuranceQuoteParams(departingDate?: string, arrivalDate?: string, coverAmount?: number, destinationCountries?: Array<string>, occupancies?: App.Occupants) {
  const endDate = sanitizeEndDate(departingDate, arrivalDate)

  return {
    type: INSURANCE_PRODUCT_TYPE.BOOKING_PROTECTION,
    productId: INSURANCE_PRODUCT_ID.CFMR,
    startDate: departingDate,
    endDate,
    coverAmount,
    destinationCountries,
    travellers: occupancies,
  } as FetchQuoteParams
}

export function getFlightSearchInsuranceQuoteKey(departingDate?: string, arrivalDate?: string, coverAmount?: number, destinationCountry?: string, occupancies?: App.Occupants) {
  return getInsuranceQuoteKey(INSURANCE_PRODUCT_ID.CFMR, getInsuranceQuoteParams(departingDate, arrivalDate, coverAmount, destinationCountry ? [destinationCountry] : [], occupancies))
}

export const FLIGHT_INSURANCE_ID_PREFIX = '-insurance'

export function restoreIdsOfInsuranceFareFamily(fareFamily: App.FlightFareFamily): App.FlightFareFamily {
  return {
    ...fareFamily,
    id: fareFamily.id.replace(new RegExp(`${FLIGHT_INSURANCE_ID_PREFIX}.*$`), ''),
    ...(
      Array.isArray(fareFamily.pairedUpsellIds) && fareFamily.pairedUpsellIds.length > 0 ? {
        pairedUpsellIds: [...new Set(fareFamily.pairedUpsellIds.map(id => id.replace(new RegExp(`${FLIGHT_INSURANCE_ID_PREFIX}.*$`), '')))],
      } : {}
    ),
  }
}
